<template>
   <div class="prompt" >
        <span class="info">{{promptInfo}}</span>
   </div>
</template>
<script>
export default {
    data(){
        return{}
    },
    props:["promptInfo"]
    
}
</script>
<style scoped>
.prompt{
    text-align: center;
    position: absolute;
    top:-0.5rem;
    /* width:10rem; */
    background:rgba(0,0,0,0.2);
    border-radius: 0.3rem;
    
}
.prompt .info{
    color:white;
    font-size:0.75rem;
    
}
</style>





// WEBPACK FOOTER //
// src/component/Prompt.vue